



















import { Vue, Component } from "vue-property-decorator";
import VueBase from "@/lib/vuebase";
import ajax from "@/lib/ajax";

@Component({})
export default class MFACodePageView extends VueBase {
  onClickLeft() {
    window.history.go(-1);
  }
  vCode: any = "";
  async mounted() {
    await ajax.get("MFA/GetMFAToken?id=" + this.$route.query.id).then((rep) => {
      this.vCode = rep.data.result;
    });
  }

}
